import { FixedWidthFieldRenderer } from './base';
import { type FieldRendererField } from './types';

const DURATION_DEFAULT_TEMPLATE = '{{fieldName}}: {{fieldValue}}';

export class DurationFieldRenderer extends FixedWidthFieldRenderer {
  static getTemplate(fieldMetadata: FieldRendererField): string {
    return (fieldMetadata.template || DURATION_DEFAULT_TEMPLATE).trim();
  }
}
